import { useEffect, useState } from 'react';
import { loadPilotState, PILOT_UPDATED_EVENT } from './store';

export function usePilotState() {
  const [state, setState] = useState(loadPilotState);

  useEffect(() => {
    const reload = () => setState(loadPilotState());
    window.addEventListener('storage', reload);
    window.addEventListener(PILOT_UPDATED_EVENT, reload);
    return () => {
      window.removeEventListener('storage', reload);
      window.removeEventListener(PILOT_UPDATED_EVENT, reload);
    };
  }, []);

  return [state, setState] as const;
}
